// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconToastClose = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 20 20' ref={ref} {...props}>
        <circle cx={10} cy={10} r={8.75} fill='#fff' stroke='#E6E9ED' strokeWidth={1.5} />
        <path
            fill='#81868C'
            d='M10 18.333A8.333 8.333 0 0 0 18.333 10 8.333 8.333 0 0 0 10 1.667 8.333 8.333 0 0 0 1.667 10 8.333 8.333 0 0 0 10 18.333M7.363 7.363a.78.78 0 0 1 1.104 0l1.53 1.53 1.53-1.53a.78.78 0 0 1 1.104 1.104l-1.53 1.53 1.529 1.53a.781.781 0 0 1-1.104 1.104l-1.53-1.53-1.53 1.53a.78.78 0 0 1-1.104-1.104l1.531-1.53-1.53-1.53a.78.78 0 0 1 0-1.104'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconToastClose)
const Memo = memo(ForwardRef)
export default Memo
